<template>
  <div>
    <Banner type="part" />
    <div class="page-container j-container-box-shadow container">
      <div class="title" v-if="loaded">
        <div class="j-title">
          {{ detail.partName ? $t(detail.partName) : '' }}
        </div>

        <!-- <a-divider type="vertical" style="margin: 0 40px; height: 30px;" />
        <div>
          <span class="model-label">{{ $t('part.model_label') }} : </span>
          <span> {{ detail.modelNum ? `${detail.modelNum}` : '' }}</span>
        </div> -->
      </div>

      <a-divider style="margin: 30px 0;" />

      <a-spin :spinning="loading">
        <a-row :gutter="[30, 30]">
          <a-col :xs="24" :sm="12">
            <div class="left-img-container">
              <!-- <img
                v-if="!!getLeftImg && loaded"
                ref="leftImg"
                @load="onImgLoad($refs['leftImg'], getLeftImg)"
                alt="part-img"
                :src="getLeftImg"
              />
              <div v-else>{{ $t('common.no_img') }}</div> -->
              <pic-zoom
                :width="width"
                :height="height"
                :url="getLeftImg"
                :type="type"
                :scale="scale"
                :out-zoomer="showType"
                :mask="false"
                :outShow="outShow"
                :zoomer-style="{
                  'background-color': 'rgba(0,0,0, 0.6)',
                  filter: filter
                    ? 'drop-shadow(16px 16px 20px red) invert(75%)'
                    : ''
                }"
              >
                <template v-if="true" v-slot:zoomer>
                  <div class="ks-imagezoom-wrap"></div>
                </template>
              </pic-zoom>

              <div v-if="isDiagramImgLoaded">
                <span
                  :key="index"
                  v-for="(c, index) in getChilds()"
                  class="img-coordinate"
                  :style="getImgCoordinateStyle(c)"
                >
                  <span
                    @mouseleave="e => handleCoordinateMouseleave(e, c.sn)"
                    @mouseenter="e => handleCoordinateMouseenter(e, c.sn)"
                    class="img-coordinate-num"
                    :ref="`img-coordinate-num-${c.sn}-${c.id}`"
                    >{{ c.sn }}</span
                  >
                </span>
              </div>
            </div>
          </a-col>

          <a-col :xs="24" :sm="12">
            <!-- :pagination="ipagination" -->

            <div class="table-container">
              <a-table
                class="table"
                size="middle"
                :row-key="'key'"
                :columns="columns"
                :data-source="dataSource"
                :pagination="false"
                :customRow="customRow"
                :scroll="{ x: 1000, y: tableY }"
              >
                <template #[`${col}-title`] v-for="col in colTitle" :key="col">
                  {{ $t(`part_detail.pt_${col}`) }}
                </template>

                <template #modelNum="{text}">
                  <span :class="'modelNum-' + text + ' modelNum'">
                    {{ text }}
                  </span>
                </template>

                <template #action="{record}">
                  <a
                    v-if="record.supplyStatus === 1"
                    class="cart"
                    @click="handleAddToCart(record)"
                  >
                    <CartIcon />
                    <span v-if="record.addedToCart" class="cart-dot"></span>
                  </a>
                </template>

                <template #photo="{record}">
                  <div v-if="getImg(record.partsImgs)" class="img-container">
                    <img alt="photo" :src="getImg(record.partsImgs)" />
                    <EnlargeIcon
                      class="enlarge-icon"
                      @click="handlePreviewImg(record)"
                    />
                  </div>
                  <span v-else>{{ $t('common.no_img') }}</span>
                </template>
              </a-table>

              <!-- <div class="pagination-container"></div> -->
            </div>
            <!-- <div class="pagination-container">
              <a-pagination
                v-model:current="ipagination.current"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
                show-size-changer
                v-model:pageSize="ipagination.pageSize"
                @showSizeChange="onShowSizeChange"
                @change="onChange"
                size="small"
                show-quick-jumper
              >
                <template #buildOptionText="props">
                  <span
                    >{{ props.value }}
                    {{ $t('common.page_per_item_text') }}</span
                  >
                </template>
              </a-pagination>
            </div> -->
          </a-col>
        </a-row>
      </a-spin>

      <PreviewImageModal
        @after-close="handleAfterClose"
        v-if="showPreviewModal"
        :images="previewImg"
      />

      <SingleStatusModal
        @after-close="handleAfterSingleClose"
        v-if="showSingleModal"
        :record="selectedRecord"
        :groupId="detail.id"
        :vehicleId="vehicleId"
      />

      <MultiStatusModal
        @after-close="handleAfterMultiClose"
        v-if="showMultiModal"
        :type="2"
        :item="selectedRecord"
      />

      <AddPartToCartModal
        @after-close="handleAfterAddCartClose"
        v-if="showAddCartModal"
        :item="addToCartRecord"
        :groupId="detail.id"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import $ from 'jquery';
import { mapState } from 'vuex';
import { useRoute } from 'vue-router';
import numeral from 'numeral';
import { message } from 'ant-design-vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import CartIcon from '@/components/icons/CartIcon.vue';
import Banner from '@/components/banner/Banner.vue';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';
import SingleStatusModal from '@/components/single-status/SingleStatusModal.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import AddPartToCartModal from '@/components/add-part-to-cart/AddPartToCartModal.vue';
import { getPartDetail } from '@/api/apis';
import { baseFileUrl } from '@/utils/constants';
import { randomUUID } from '@/utils/util';
import PicZoom from '@/components/zoom/vue-photo-zoom-pro.vue';

interface PartDetailProps {
  columns: any[];
  dataSource: any[];
  [key: string]: any;
  previewImg: string[];
}

export default defineComponent({
  name: 'PartDetail',
  components: {
    EnlargeIcon,
    CartIcon,
    PreviewImageModal,
    MultiStatusModal,
    SingleStatusModal,
    AddPartToCartModal,
    Banner,
    PicZoom
  },
  data(): PartDetailProps {
    return {
      loading: false,
      loaded: false,
      colTitle: [
        'sn',
        'photo',
        'name',
        'no',
        'code',
        'unit',
        'quantity',
        'uprice',
        'remark',
        'action'
      ],
      vehicleId: 0,
      columns: [
        {
          dataIndex: 'sn',
          width: 80,
          slots: { title: 'sn-title' }
        },
        {
          dataIndex: 'partName',
          width: 140,
          customRender: ({ text }) => {
            return text ? this.$t(text) : '';
          },
          slots: { title: 'name-title' }
        },
        {
          dataIndex: 'modelNum',
          width: 140,
          slots: { customRender: 'modelNum', title: 'no-title' }
        },
        {
          dataIndex: 'partCode',
          width: 140,
          slots: { title: 'code-title' }
        },
        {
          dataIndex: 'remark',
          customRender: ({ text }) => {
            return text ? this.$t(text) : '';
          },
          width: 100,
          slots: { title: 'remark-title' }
        },
        {
          dataIndex: 'unit',
          customRender: ({ text }) => {
            return text ? this.$t(text) : '';
          },
          width: 100,
          slots: { title: 'unit-title' }
        },
        {
          dataIndex: 'quantity',
          width: 100,
          slots: { title: 'quantity-title' }
        },
        {
          dataIndex: 'sellingPrice',
          customRender: ({ text }) => {
            return text !== null ? numeral(text).format('$0.00') : '';
          },
          width: 100,
          slots: { title: 'uprice-title' }
        },
        {
          dataIndex: 'partsImgs',
          slots: { customRender: 'photo', title: 'photo-title' },
          width: 100
        },
        {
          key: 'action',
          slots: { customRender: 'action', title: 'action-title' },
          width: 90,
          fixed: 'right'
        }
      ],
      dataSource: [],
      detail: {},
      previewImg: [],
      showPreviewModal: false,
      showSingleModal: false,
      showMultiModal: false,
      selectedRecord: {},

      showAddCartModal: false,
      addToCartRecord: {},

      tableY: 800,

      // 图片比例
      wScale: 1,
      hScale: 1,

      isDiagramImgLoaded: false,

      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
      },
      scale: 3.0,
      type: 'square',
      showType: true,
      changeImgPosition: false,
      width: 168,
      taobao: true,
      filter: false,
      height: -1,
      outShow: true,
    };
  },
  created() {
    const route = useRoute();

    const params = route.params;

    const query = route.query;

    if (params.id) {
      this.loadData(params.id, query,params.vehicleId);
    }
    this.vehicleId = params.vehicleId;
  },
  computed: {
    getLeftImg() {
      let res = '';

      const partsImgs = this.detail.partsImgs || [];

      if (partsImgs.length > 0) {
        if (partsImgs.length === 2 && partsImgs[1].fileUrl) {
          res = baseFileUrl + partsImgs[1].fileUrl;
        } else {
          if (partsImgs[0].fileUrl) {
            res = baseFileUrl + partsImgs[0].fileUrl;
          }
        }
      }

      return res;
    },
    ...mapState(['lang', 'userInfo']),
  },
  methods: {
    // handleTableChange(pagination) {
    //   this.ipagination = pagination;
    // },
    onShowSizeChange(current) {
      this.ipagination.current = current;
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;
    },
    getImg(partsImgs) {
      let res = '';

      const imgs = partsImgs || [];

      if (imgs.length > 0 && imgs[0].fileUrl) {
        res = baseFileUrl + imgs[0].fileUrl;
      }

      return res;
    },
    async loadData(id, query, verticalId) {
      const isThroughSearch = query.name || query.modelNum;
      const params: any = {
        currentPartsId: +id
      };
      if (isThroughSearch) {
        params.childModelNum = query.modelNum
          ? query.modelNum.trim()
          : query.modelNum;
        params.childName = query.name ? query.name.trim() : query.name;
      }
      this.loading = true;
      params.local = this.lang;
      params.vehicleId = verticalId;
      const res = await getPartDetail(params);

      if (res.success) {
        this.detail = res.result || {};

        this.dataSource = (this.detail.childs || []).map(s => {
          return {
            ...s,
            key: randomUUID()
          };
        });

        this.ipagination = {
          ...this.ipagination,
          total: this.dataSource.length
        };
      }

      this.loading = false;

      this.loaded = true;
    },
    handleAddToCart(record) {
      if (record.addedToCart) {
        message.error(this.$t('single_status.already_added'));
        return;
      }
      this.selectedRecord = record;
      if (record.differentStatus === 0) {
        this.showSingleModal = true;
      } else {
        this.showMultiModal = true;
      }
    },
    handlePreviewImg(record) {
      // const img = this.getImg(record.partsImgs);

      this.previewImg.push(
        ...(record.partsImgs || [])
          .filter(s => s.fileUrl)
          .map(s => baseFileUrl + s.fileUrl)
      );

      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    handleAfterSingleClose(addedToCart) {
      this.selectedRecord.addedToCart = addedToCart;
      this.showSingleModal = false;
    },
    handleAfterMultiClose(data, isCancel) {
      if (!isCancel) {
        this.addToCartRecord = data;
        this.showAddCartModal = true;
      }
      this.showMultiModal = false;
    },
    handleAfterAddCartClose(isCancel) {
      if (!isCancel) {
        const item = this.dataSource.find(
          s => s.modelNum === this.addToCartRecord.modelNum
        );

        if (item) {
          item.addedToCart = true;
        }

        this.dataSource = [...this.dataSource];
      }
      this.showAddCartModal = false;
    },
    // 坐标
    getChilds() {
      return (this.detail.childs || []).filter(s => s.sn > 0 && s.area);
    },
    customRow(record, index) {
      return {
        onMouseenter: event => {
          const ref = this.$refs[
            `img-coordinate-num-${record.sn}-${record.id}`
          ];
          if (ref) {
            if (ref instanceof Array && ref.length === 1) {
              this.handleRowMouseenter(event, ref[0]);
            } else if (ref instanceof Element) {
              this.handleRowMouseenter(event, ref);
            }
          }
        }, // 鼠标移入行
        onMouseleave: event => {
          const ref = this.$refs[
            `img-coordinate-num-${record.sn}-${record.id}`
          ];
          if (ref) {
            if (ref instanceof Array && ref.length === 1) {
              this.handleRowMouseleave(event, ref[0]);
            } else if (ref instanceof Element) {
              this.handleRowMouseleave(event, ref);
            }
          }
        },
        class: `part-table-${record.sn}`
      };
    },
    handleCoordinateMouseenter(e, sn) {
      const els: any[] = Array.from(
        document.querySelectorAll(`.part-table-${sn}`)
      );
      if (els && els.length > 0) {
        els.forEach((e, i) => {
          e.style.background = '#ccd6eb';
          if (i === 0) {
            $('.ant-table-body-inner').animate(
              {
                scrollTop: e.offsetTop + 'px'
              },
              300
            );
          }
        });
      }
    },
    handleCoordinateMouseleave(e, sn) {
      const els: any[] = Array.from(
        document.querySelectorAll(`.part-table-${sn}`)
      );
      if (els && els.length > 0) {
        els.forEach(e => {
          e.style.background = '';
        });
      }
    },
    handleRowMouseleave(e, el) {
      if (el) {
        el.style.background = '';
        el.style.visibility = '';
        el.style.transition = '';
      }
    },
    handleRowMouseenter(e, el) {
      if (el) {
        el.style.background = '#ccd6eb';
        el.style.visibility = 'visible';
        el.style.transition = 'all 0.3s';
      }
    },
    getImgCoordinateStyle(child) {
      const areas = child.area.split(',');
      const left = +areas[0] || 0;
      const top = +areas[1] || 0;
      return {
        top: `${numeral(top)
          .multiply(this.hScale)
          .value()}px`,
        left: `${numeral(left)
          .multiply(this.wScale)
          .value()}px`
      };
    },
    onImgLoad(imgEl, src) {
      if (imgEl && src) {
        const img = new Image();
        img.src = src;

        const oriWidth = img.width;
        const oriHeight = img.height;

        const currentWidth = imgEl.offsetWidth;

        const currentHeight = imgEl.offsetHeight;

        this.tableY = currentHeight;

        this.wScale = numeral(currentWidth)
          .divide(oriWidth)
          .value();

        this.hScale = numeral(currentHeight)
          .divide(oriHeight)
          .value();

        this.isDiagramImgLoaded = true;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  padding-bottom: 24px;
  background-color: white;

  .title {
    padding: 32px 0 0 0;
    display: flex;
    align-items: center;
    color: $primary-color;
  }

  img {
    display: block;
    width: 100%;
    /* height: 100%; */
  }

  .img-container {
    position: relative;
    width: 80px;
    img {
      height: 50px;
      width: 80px;
      object-fit: contain;
    }
    .enlarge-icon {
      position: absolute;
      top: 4px;
      right: 4px;
    }
  }

  // 坐标
  .left-img-container {
    position: relative;

    .img-coordinate {
      position: absolute;
      z-index: 1;
      display: block;
      cursor: pointer;
      font-size: 12px;
      font-weight: bold;
      .img-coordinate-num {
        width: 34px;
        height: 34px;
        transform: scale(0.7); // 缩小
        display: flex;
        align-items: center;
        justify-content: center;
        visibility: hidden;
        background: white;
        border-radius: 50%;
        border: 2px solid $primary-color;
        color: $primary-color;
      }
      &:hover {
        .img-coordinate-num {
          background: $table-hover-bg-color;
          visibility: visible;
          transition: all 0.3s;
        }
      }
    }
  }

  .cart {
    position: relative;
    display: block;
    font-size: 16px;

    .cart-dot {
      position: absolute;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: red;
      top: calc(50% - 2px);
      left: 10px;
    }
  }
}

.pagination-container {
  margin: 20px 0;
  text-align: right;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .table {
    flex: 1;
  }
}

// 隐藏table自带的pagination
::v-deep(.ant-table-pagination) {
  display: none;
}

// ::v-deep(.ant-table-wrapper) {
//   box-shadow: $container-boxshadow;
// }
</style>
